import type { FunctionComponent } from "react";

import {
  HeaderBottomLine,
  HeaderBottomLineContainer,
  HeaderContainer,
  HeaderDescription,
  HeaderLogoAndDescription,
  HeaderLogoContainer,
} from "./styles";

type Props = {
  description: string;
  logo: JSX.Element;
};

export const SpecialIndexHeader: FunctionComponent<Props> = ({ description, logo }) => (
  <HeaderContainer>
    <HeaderLogoAndDescription>
      <HeaderLogoContainer>{logo}</HeaderLogoContainer>
      <HeaderDescription>{description}</HeaderDescription>
    </HeaderLogoAndDescription>
    <HeaderBottomLineContainer>
      <HeaderBottomLine />
    </HeaderBottomLineContainer>
  </HeaderContainer>
);

SpecialIndexHeader.displayName = "SpecialIndexHeader";
